var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-main"},[_c('HeaderIndex',{staticClass:"site-header",on:{"menuClick":_vm.menuClick}}),_c('PageIndex',{ref:"pageContainer",staticClass:"site-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }